import React from "react";
import NewsTicker from "../../global/newsTicker";

const renderList = component => {
  switch (component.listType) {
    case "newsTicker":
      return <NewsTicker content={component.entries} />;
    default:
      return null;
  }
};

export default function PageList({ component }) {
  return renderList(component);
}
